var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-10 mx-auto"},[_c('div',[_c('page-title',{attrs:{"title":_vm.$t('sideMenu.releaseInfo'),"showTitle":false}})],1),_c('div',{staticClass:"mb-5"},[_c('ReleaseInfo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }